"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breedLimitsValidationSchema = void 0;
const yup_1 = require("yup");
exports.breedLimitsValidationSchema = (0, yup_1.object)().shape({
    count: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    time: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    maxTime: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map